import { useHistory, useLocation } from 'react-router-dom';
import { SyntheticEvent, useMemo } from 'react';

export type CloseDialogFunc = (
  arg1?: unknown | boolean | SyntheticEvent | number,
  arg2?: 'backdropClick' | 'escapeKeyDown' | number
) => void;

interface IOptions {
  replace: boolean;
}

export const useCloseDialog = (url?: string, resetQueryParams: string[] = [], options: Partial<IOptions> = {}) => {
  const history = useHistory();
  const { search, pathname } = useLocation();

  const notNullUrl = url ?? pathname;

  const fullOptions = useMemo<IOptions>(
    () => ({
      replace: true,
      ...options,
    }),
    [options]
  );

  return useMemo(() => {
    function closeDialog(resetQuery: boolean): void;
    function closeDialog(event: unknown | SyntheticEvent, reason?: 'backdropClick' | 'escapeKeyDown'): void;
    function closeDialog(page: number, per: number): void;
    function closeDialog(highlight: number): void;
    function closeDialog(): void;

    function closeDialog(
      arg1?: boolean | unknown | SyntheticEvent | number,
      arg2?: 'backdropClick' | 'escapeKeyDown' | number
    ) {
      const historyMethod = fullOptions.replace ? history.replace : history.push;

      if (arg1 === true) {
        historyMethod(notNullUrl);
      } else if (typeof arg1 === 'number' && typeof arg2 === 'number') {
        historyMethod(`${notNullUrl}?page=${arg1}&per=${arg2}`);
      } else if (typeof arg1 === 'number') {
        const newSearch = new URLSearchParams(search);
        newSearch.delete('page');
        newSearch.set('highlight', arg1.toString(10));
        historyMethod(`${notNullUrl}?${newSearch}`);
      } else {
        const newSearch = new URLSearchParams(search);

        for (const query of resetQueryParams) {
          newSearch.delete(query);
        }

        if (newSearch.toString()) {
          historyMethod(`${notNullUrl}?${newSearch.toString()}`);
        } else {
          historyMethod(notNullUrl);
        }
      }
    }
    return closeDialog;
  }, [notNullUrl, search, fullOptions]);
};
